import React, {Component} from 'react';

import APIClient from './Api';

const client = new APIClient();


class Counter extends Component {

  constructor(props) {
    super(props);
    this.state = {
      count: 0
    };
  }

  componentDidMount() {
    client.getNumberOfContribs().then(({total_counter}) => {
      this.setState({count: total_counter});
    });
  }

  render() {
    const { count } = this.state;
    const hide = count < 1200;
    return (
      <div className={`gp-compteur${hide ? ' gp-hidden' : ''}`}>
        <p>
          Déjà <span class="count">{count.toLocaleString('fr-fr')}</span> témoignages
        </p>
        {/* Si ça revient...
          <p class="gp-title-sous">
            Ce compteur répertorie tous les témoignages partagés
            sur les réseaux sociaux ou directement sur ce site internet.
          </p>
        */}
      </div>
    );
  }
}

export default Counter;
